export const collectionKey = "collection";
export const siteSettingsKey = "siteSettings";
export const adminPasswordKey = "adminPassword";